import { ThemeIndex } from "@/constant/theme";

export const CHATROOM_STATE = {
  JNOIN_CHATROOM_SUCCESS: 1,
  JNOIN_CHATROOM_FAIL: 2,
  QUIT_CHATROOM_SUCCESS: 3,
  QUIT_CHATROOM_FAIL: 4,
  PULL_HISTORY_ITEM_COUNT: 0
};
export const MESSAGE_TYPE = {
  //常量命名貌似别使用":"等内建字符
  IMAGE: "ImageMessage",
  TEXT: "TextMessage",
  VOICE: "VoiceMessage",
  WEL: "TG:LotteryTipsForSelfMessage",
  BETTING: "TG:BettingMsg",
  BETPLAN_BOT: "TG:BetplanBotMsg",
  LOTTERY_EMOJI: "TG:LotteryEmojiMessage", // gif表情
  JOIN_CHATROOM: "TG:LotteryWelcomeJoinMessage", // 加入聊天室
  RED_PACKET: "TG:HBMsg",
  RED_PACKET_BATTLE: "TG:HbdzMsg"
};
export const BANNED_TEXT = {
  0: "",
  1: "晋级为高段位会员就可以发言",
  2: "您已被禁言，请联系客服",
  3: "全局禁言中"
};

export const MESSAGE_NAME = {
  IMAGE: "ImageMessage",
  TEXT: "TextMessage",
  VOICE: "VoiceMessage",
  BETTING: "BettingMessage",
  RED_PACKET: "redPacketMessage",
  LOTTERY_EMOJI_MESSAGE: "LotteryEmojiMessage"
};

export const SCROLL_PAGE_STATE = {
  COMPLETE: 0,
  PEDDING: 1,
  NO_MORE: 2,
  NO_DATA: 3
};
/* 1为聊天室跟单，2为聊天室投注，3为抢庄房间投注，4为抢庄房间跟单，其他为页面投注 */
export const BETTING_FOLLOW_STATE = {
  CHATROOM_BETTING_FOLLOW: 1, // 聊天室跟单下注
  GRAPROOM_BETTING: 3, // 抢庄房下注
  GRAPROOM_BETTING_FOLLOW: 4 // 抢庄房跟单下注
};

export const kUserMarkType = {
  unLogin: "kUserMarkType_UnLogin", // 未登录
  tryUser: "kUserMarkType_Guest", //
  user: "kUserMarkType_Login"
};

export const THEME_CONFIG = [
  {
    primaryName: "玫瑰红",
    primaryColor: "#d82e2f",
    isDark: false,
    linearGradient: "none"
  }, //玫瑰红
  {
    primaryName: "珊瑚色",
    primaryColor: "#df4f1a",
    isDark: false,
    linearGradient: "none"
  }, //珊瑚色
  {
    primaryName: "草绿",
    primaryColor: "#14bd58",
    linearGradient: "none"
  }, //草绿
  {
    primaryName: "宝石蓝",
    primaryColor: "#4169E1",
    linearGradient: "none"
  }, //宝石蓝
  {
    primaryName: "金麒麟",
    primaryColor: "#d09700",
    linearGradient: "none"
  }, //金麒麟色
  {
    primaryName: "紫罗兰",
    primaryColor: "#8A2BE2",
    linearGradient: "none"
  }, //紫罗兰色
  {
    primaryName: "红橙",
    primaryColor: "#FF4500",
    linearGradient: "none"
  }, //红橙色
  {
    primaryName: "罂粟红",
    primaryColor: "#ec0000",
    linearGradient: "none"
  }, //罂粟红
  {
    primaryName: "高贵蓝",
    primaryColor: "#213862",
    linearGradient: "none"
  } //高贵蓝
];

export const THEME_CONFIG_MORE = [
  {
    name: "红色系",
    clrDisr: ["软红", "蜡黄", "纽约粉红"],
    colors: [
      { primaryColor: "#CF000F" },
      { primaryColor: "#D91E18" },
      { primaryColor: "#F22613" },
      { primaryColor: "#F03434" },
      { primaryColor: "#EC644B" },
      { primaryColor: "#E08283" },
      { primaryColor: "#F1A9A0" }
    ]
  },
  {
    name: "紫色系",
    clrDisr: ["中紫", "电紫", "薰衣草紫"],
    colors: [
      { primaryColor: "#736598" },
      { primaryColor: "#663399" },
      { primaryColor: "#963694" },
      { primaryColor: "#8C14FC" },
      { primaryColor: "#A537FD" },
      { primaryColor: "#A537FD" }
    ]
  },
  {
    name: "篮色系",
    clrDisr: ["水手", "鲨鱼", "夏尔巴篮"],
    colors: [
      { primaryColor: "#22313F" },
      { primaryColor: "#4D13D1" },
      { primaryColor: "#5333ED" },
      { primaryColor: "#2C82C9" },
      { primaryColor: "#00B5CC" }
    ]
  },
  {
    name: "绿色系",
    clrDisr: ["海洋", "夏绿", "孔雀石"],
    colors: [
      { primaryColor: "#4ECDC4" },
      { primaryColor: "#23CBA7" },
      { primaryColor: "#29F1C3" },
      { primaryColor: "#7BEFB2" }
    ]
  },
  {
    name: "黄色系",
    clrDisr: ["能量黄", "浅黄", "蓝黄白"],
    colors: [
      { primaryColor: "#F4D03F" },
      { primaryColor: "#FAD859" },
      { primaryColor: "#F5D76E" },
      { primaryColor: "#F5E51B" },
      { primaryColor: "#F0FF00" }
    ]
  },
  {
    name: "橙色系",
    clrDisr: ["加州橙", "生动", "胡萝卜橙"],
    colors: [
      { primaryColor: "#D35400" },
      { primaryColor: "#F15A22" },
      { primaryColor: "#E47833" },
      { primaryColor: "#F9B42D" },
      { primaryColor: "#FCB941" }
    ]
  },
  {
    name: "灰色系",
    clrDisr: ["银沙灰", "水星", "外太空"],
    colors: [
      { primaryColor: "#2E3131" },
      { primaryColor: "#67809F" },
      { primaryColor: "#BDC3C7" }
    ]
  }
];

const TEMPLATE = {
  temp: {
    isDark: false,
    ...THEME_CONFIG[configText.defaultTheme || 0]
  }, //模板一
  temp1: {
    primaryColor: "#e4393c",
    isDark: false,
    index: 2,
    linearGradient: "none"
  }, //模板3 娱乐城
  temp2: {
    primaryColor: "#dfbf67",
    isDark: true,
    index: 3,
    linearGradient: "#dfbf67"
  }, // 国际版
  temp3: {
    primaryColor: "#FF464B",
    isDark: false,
    index: 4,
    linearGradient: "none"
  }, //娱乐城国际版
  temp4: {
    primaryColor: "#FF464B",
    isDark: false,
    index: 1,
    linearGradient: "none"
  }, //模板1 经典版
  temp5: {
    primaryColor: "#dfbf67",
    isDark: false,
    index: 5,
    linearGradient: "#dfbf67"
  }, //国际新模版
  temp6: {
    primaryColor: "#1F6EFE",
    isDark: false,
    index: 6,
    linearGradient: "#1F6EFE"
  }, //蓝白模版
  temp7: {
    primaryColor: "#1F6EFE",
    isDark: false,
    index: 7,
    linearGradient: "#1F6EFE"
  }, //蓝白首页替换新模版
  temp8: {
    primaryColor: "#dfbf67",
    isDark: false,
    index: 8,
    linearGradient: "linear-gradient(to right, #88671e, #c7a854)"
  } //游戏风格
};

export function getTemplateConfig() {
  const tpls = [];
  const { pageTemplate } = configText;
  if (pageTemplate) {
    for (const key in pageTemplate) {
      const item = pageTemplate[key];
      item.key = key;
      tpls.push({
        ...item,
        ...TEMPLATE[key]
      });
    }
  }
  return tpls;
}

// 不同模板路由,用在： 例如聊天室跳到群聊，经典版和其他版本的群聊路由名称不同
export const TEMPLATE_ROUTES = {
  v: "groupChat",
  v1: "groupChat",
  v2: "chatMain" // 经典版跳到 groupChat,3.0版跳到 chatMain
};

export const CHAT_ROOM_DEFAULT_MSG = {
  DEF_MSG: "晋级为高段位会员就可以发言",
  DEF_MSG2: "您已被禁言，请联系客服",
  DEF_MSG3: "全局禁言中",
  DEF_MSG4: "当前用户等级已被禁言，请联系客服",
  DEF_MSG5: "房间禁言中",
  DEF_MSG6: "您当前无法进入此聊天室,即将被踢出,请联系管理员！"
};
